export * from './team-member-card.component';
export * from './team-member-card.module';
